import type {
  DeprecatedTabsContentOption,
  DeprecatedTabsTriggerOption,
} from "@v1/components/designSystem/tabs/Tabs";
import type { BrandDetailsTab } from "./BrandDetailsContext";

import * as React from "react";

import { DeprecatedTabs } from "@v1/components/designSystem/tabs/Tabs";
import { analytics } from "@v2/features/infra/analytics/tracking";

import BrandContextEditor from "./BrandContextEditor";
import { useBrandDetailsTabs } from "./BrandDetailsContext";
import ShopStylesEditor from "./ShopStylesEditor";

const BRAND_DETAILS_TABS: DeprecatedTabsTriggerOption[] = [
  { value: "styles", label: "Styles" },
  { value: "context", label: "Context" },
];

const BRAND_DETAILS_CONTENT: DeprecatedTabsContentOption[] = [
  { value: "styles", tabContent: <ShopStylesEditor /> },
  { value: "context", tabContent: <BrandContextEditor /> },
];

const BrandDetailsPane: React.FC = () => {
  const { selectedTab, setSelectedTab } = useBrandDetailsTabs();

  const onChange = (value: string) => {
    const tab = value as BrandDetailsTab;
    setSelectedTab(tab);
    analytics.logEvent("brandDetails.tabSelected", {
      tab,
    });
  };

  return (
    <div className="flex h-fit min-h-0 flex-col gap-y-2 overflow-x-hidden p-3 pb-0 pt-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <DeprecatedTabs
        defaultValue={selectedTab}
        value={selectedTab}
        onValueChange={onChange}
        tabsOptions={BRAND_DETAILS_TABS}
        contentOptions={BRAND_DETAILS_CONTENT}
      />
    </div>
  );
};

export default BrandDetailsPane;
